<template>
    <div style="width: 100%;text-align: center;margin-top: 10px">
        <el-form ref="form" :model="form" label-width="150px">
            <el-form-item label="1 Star">
                <el-input-number v-model="form[0]" :min="0" :max="10000"></el-input-number>
            </el-form-item>

            <el-form-item label="2 Star">
                <el-input-number v-model="form[1]" :min="0" :max="10000"></el-input-number>
            </el-form-item>

            <el-form-item label="3 Star">
                <el-input-number v-model="form[2]" :min="0" :max="10000"></el-input-number>
            </el-form-item>

            <el-form-item label="4 Star">
                <el-input-number v-model="form[3]" :min="0" :max="10000"></el-input-number>
            </el-form-item>

            <el-form-item label="5 Star">
                <el-input-number v-model="form[4]" :min="0" :max="10000"></el-input-number>
            </el-form-item>

            <el-form-item label="Cancel Penalty">
                <el-input-number v-model="form[5]" :min="0" :max="10000"></el-input-number>
            </el-form-item>
        </el-form>

        <el-divider/>

        <el-button type="warning" size="medium" @click="loadData">Reset</el-button>
        <el-button type="primary" size="medium" @click="saveData">Save</el-button>
    </div>
</template>

<script>
    import {getDict, saveDict} from "@/api/SettingAPI.js"

    export default {
        name: "HelperPrice",
        data() {
            return {
                form: [0, 0, 0, 0, 0],
                dict: {}
            }
        }, methods: {
            loadData() {
                getDict("HELPER_PRICE")
                    .then(resp => {
                        this.dict = resp.data
                        this.form = JSON.parse(this.dict.value)
                    })
            },
            saveData() {
                this.dict.value = JSON.stringify(this.form)
                saveDict(this.dict)
                    .then(() => this.loadData())
            }
        }, created() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>
